<template>
<div class="h-fit w-full bg-white flex flex-col xs:flex-row p-6  xs:p-3">
     <div class="text-base text-justify h-full ">
        <div class="flex flex-row xs:flex-col">
              <div class="w-full h-fit grow ">
                <!-- <img src="https://media.pafcpic.net/images/misc/pafcpic.jpg" class="w-full h-full xs:hidden min-w-max max-h-96 pb-2" />
                 <img src="https://media.pafcpic.net/images/misc/pafcpic.jpg" class="w-full h-full sm:hidden md:hidden  max-h-96 pb-2" /> -->
            </div>
            <div class="pl-96 xs:pl-0">
            PAFCPIC stands for the Philippine Army Finance Center Producers Integrated Cooperative, affectionately
            referred to by its members as &quot;PAPSI&quot;. PAFCPIC is a multi-awarded cooperative offering financial
            services through deposits and loans to its members serving in the Armed Forces of the Philippines.
            Its membership consists of military and civilian personnel ( both active and retired ) of the Philippine
            Army, Philippine Navy and Philippine Air Force, as well as their immediate dependents.With its current
            membership totaling more than 160,000 members. Its main office is located
            </div>
        </div>
        <div class="py-3">
             along Bayani Road in Fort
            Bonifacio, Taguig City and has 25 satellite offices and 27 liaison offices across the country.
            PAFCPIC is the first institution-based category winner of Gawad para sa Pinakatanging Kooperatiba
            (Gawad PITAK) of the Land Bank of the Philippines in 2004. It was the first cooperative recognized for
            Family Welfare and Community Development in 2004 and for Labor-Management Relations in 2013
            under the Search for Model Companies by the Department of Trade and Industry (DTI) Center for
            Industrial Competitiveness. It was also the first cooperative to have been bestowed the Philippine
            Quality Challenge Level 2 Award in 2015 by the DTI Competitiveness Bureau in partnership with the
            Philippine Society for Quality Inc.
        </div>
        <div class="py-2">
            PAFCPIC is currently registered with the Cooperative Development Authority (CDA) under Registry
            Number 9520-16000421 dated 16 October 2009.
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import mixin from "./../../mixin";

export default defineComponent({
    mixins: [
        mixin,
    ],
})
</script>

<style scoped>
.strip-banner {
    height: 240px !important;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
}
</style>